import { Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  bgColor?: string;
  children: ReactNode;
};

const IconBackground = ({ children, bgColor = 'primaryColor' }: Props) => (
  <Flex
    background={bgColor}
    boxSize="25px"
    minWidth="25px"
    borderRadius="50%"
    alignItems="center"
    justifyContent="center"
  >
    {children}
  </Flex>
);

export default IconBackground;
